import CustomTextField from 'components/Input/CustomTextField';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { debounce } from 'lodash';

const SLayout = styled.div``;

const Filter = ({ onChange = (value) => null }) => {
    const [value, setValue] = useState('');

    const debounceSetSection = debounce((value) => onChange(value), 800);

    useEffect(() => {
        debounceSetSection(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
        <SLayout>
            <CustomTextField
                label={'Filter keyword'}
                // placeholder={'Filter Result'}
                style={{ width: 250 }}
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
        </SLayout>
    );
};

export default Filter;
